function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Open_new_window"
}, /*#__PURE__*/React.createElement("path", {
  d: "M283.5 240.9H0V42.6h148.8v28.3H28.3v141.7h226.8v-35.4h28.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.2 42.5v28.4h57.9l-60.8 60.7 20.1 20.1 60.7-60.8v57.9h28.4V42.5z"
}))));